import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8;
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Config from '../../config';
var Row = styled.div.withConfig({
  displayName: "Row",
  componentId: "sc-1sosyi2-0"
})(["box-sizing:border-box;display:flex;flex:0 1 auto;flex-wrap:wrap;flex-direction:", ";", " ", " ", " ", " ", " ", " ", " ", ";"], function (p) {
  return p.reverse ? 'row-reverse' : 'row';
}, function (p) {
  return p.start && Config.media[p.start](_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    justify-content: flex-start;\n    text-align: start;\n  "])));
}, function (p) {
  return p.center && Config.media[p.center](_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    justify-content: center;\n    text-align: center;\n  "])));
}, function (p) {
  return p.end && Config.media[p.end](_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    justify-content: flex-end;\n    text-align: end;\n  "])));
}, function (p) {
  return p.top && Config.media[p.top](_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    align-items: flex-start;\n  "])));
}, function (p) {
  return p.middle && Config.media[p.middle](_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n    align-items: center;\n  "])));
}, function (p) {
  return p.bottom && Config.media[p.bottom](_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n    align-items: flex-end;\n  "])));
}, function (p) {
  return p.around && Config.media[p.around](_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n    justify-content: space-around;\n  "])));
}, function (p) {
  return p.between && Config.media[p.between](_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n    justify-content: space-between;\n  "])));
});
Row.propTypes = {
  /** Reverse flex direction */
  reverse: PropTypes.bool,
  /** Start alignment */
  start: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl']),
  /** Center alignment */
  center: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl']),
  /** End alignment */
  end: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl']),
  /** Top alignment */
  top: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl']),
  /** Middle alignment */
  middle: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl']),
  /** Bottom alignment */
  bottom: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl']),
  /** Around alignment */
  around: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl']),
  /** Between alignment */
  between: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl'])
};
/** @component */

export default Row;